import React, { ReactElement } from 'react';
import { StyleSheet } from 'react-native';
import { Link as UnprotectedLink, LinkProps } from 'react-router-dom';

import { filterNative } from 'cross-platform/utils/roleProps';
const flatten = StyleSheet.flatten;

const Link = ({ style, ...rest }: LinkProps): ReactElement => (
  <UnprotectedLink style={flatten(style)} {...filterNative(rest)} />
);

export default Link;
